const calculateOneTimeBenefitCurrentVsLastweek = (initiatives) => {
  const l0ToL2 = ['L0', 'L1', 'L2', 'Submitted for L1 Approval', 'Submitted for L2 Approval', 'Submitted for L3 Approval'];
  const L3ToL5 = ['L3', 'L4', 'L5', 'Submitted for L4 Approval', 'Submitted for L5 Approval'];

  // Helper to get the single numerical plan or actual value from annualizedValues
  const getImpactValue = (impact, type) => {
      if (!impact || !impact.annualizedValues) {
          return 0;
      }
      const value = impact.annualizedValues[type]; // 'plan' or 'actual'
      return typeof value === 'number' ? value : 0;
  };

  const calculateTotalOneTimeBenefit = (initiative) => {
      const impacts = initiative.impact || [];

      if (!impacts || impacts.length === 0) {
          return NaN; // Indicate no impact
      }

      let oneTimeBenefit = 0;

      // Using initiative.stage directly as per provided logic context
      const currentStage = initiative.stage;

      if (currentStage) {
          if (l0ToL2.includes(currentStage)) {
              oneTimeBenefit = impacts
                  .filter((impact) => impact.frequencyAndDirection === 'One Time Benefit (ETB)') // Ensure consistent string
                  .reduce((sum, impact) => sum + getImpactValue(impact, 'plan'), 0);
          } else if (L3ToL5.includes(currentStage)) {
              oneTimeBenefit = impacts
                  .filter((impact) => impact.frequencyAndDirection === 'One Time Benefit (ETB)') // Ensure consistent string
                  .reduce((sum, impact) => sum + getImpactValue(impact, 'actual'), 0);
          }
      }
      return oneTimeBenefit;
  };

  const now = new Date();
  const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

  const rangeInitiativesMap = {
      '<not set>': [],
      'Increased by > 1 ETB m': [],
      'Increased by 0.1-1 ETB m': [],
      'Increased by < 0.1 ETB m': [],
      'Unchanged': [],
      'Decreased by < 0.1 ETB m': [],
      'Decreased by 0.1-1 ETB m': [],
      'Decreased by > 1 ETB m': [],
  };

  initiatives.forEach((initiative) => {
      const history = initiative.history || [];
      const impactUpdateHistory = history.filter(
          (entry) =>
              entry.action &&
              entry.action.includes('Impact number') &&
              entry.action.includes('has been updated.')
      );

      const oldImpactHistories = impactUpdateHistory.filter((entry) => new Date(entry.timestamp) < oneWeekAgo);

      oldImpactHistories.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

      let lastKnownNewAnnualizedPlan = 0;
      // For one-time benefit, we just track the 'new' value of the last relevant update.
      // There's no 'net' aspect like recurring benefit/negative impact.

      // Iterate through oldImpactHistories to find the last recorded 'new' annualized plan values
      // for 'One Time Benefit'.
      for (let i = 0; i < oldImpactHistories.length; i++) {
          const entry = oldImpactHistories[i];
          if (
              entry.changes &&
              entry.changes.impact && // Assuming impact changes are nested under an 'impact' key
              entry.changes.impact.new &&
              typeof entry.changes.impact.new.annualizedValues?.plan === 'number'
          ) {
              const newPlanValue = entry.changes.impact.new.annualizedValues.plan;

              if (entry.action.includes('One Time Benefit (ETB)')) { // Ensure consistent string
                  lastKnownNewAnnualizedPlan = newPlanValue; // We take the last known value
                  break; // Found the most recent, so stop
              }
          }
      }

      const currentValue = calculateTotalOneTimeBenefit(initiative);
      const lastWeekValue = lastKnownNewAnnualizedPlan;

      let range = '<not set>';

      if (isNaN(currentValue)) {
          range = '<not set>'; // Case of no Impact
      } else if (currentValue === lastWeekValue) {
          range = 'Unchanged'; // Case current equals last week
      } else {
          const difference = currentValue - lastWeekValue;

          if (difference > 1000000) {
              range = 'Increased by > 1 ETB m';
          } else if (difference >= 100000 && difference <= 1000000) {
              range = 'Increased by 0.1-1 ETB m';
          } else if (difference > 0 && difference < 100000) {
              range = 'Increased by < 0.1 ETB m';
          } else if (difference < 0 && difference > -100000) {
              range = 'Decreased by < 0.1 ETB m';
          } else if (difference <= -100000 && difference >= -1000000) {
              range = 'Decreased by 0.1-1 ETB m';
          } else if (difference < -1000000) {
              range = 'Decreased by > 1 ETB m';
          }
      }

      rangeInitiativesMap[range].push(initiative);
  });

  return rangeInitiativesMap;
};

export default calculateOneTimeBenefitCurrentVsLastweek;